import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { PUBLIC_URL } from '../../config';

export const RunnerCard = ({
    clothNumber,
    horseName,
    jockeyName,
    trainerName,
    silk,
    showSkybetLink,
    skybetLinkHref
}) => {
    return (
        <Styled.Wrapper>
            <Styled.RunnerWrapper>
                <Styled.LeftBody>
                    <Styled.ClothNumber>{clothNumber}</Styled.ClothNumber>
                    <Styled.Silk src={silk ?? '/img/default-silk.png'} />
                </Styled.LeftBody>
                <Styled.RightBody>
                    <Styled.HorseName>{horseName}</Styled.HorseName>
                    <Styled.TrainerAndJockey>
                        <strong>T</strong>: {trainerName}
                        <Styled.Divider> | </Styled.Divider>
                        <strong>J</strong>: {jockeyName}
                    </Styled.TrainerAndJockey>
                </Styled.RightBody>
            </Styled.RunnerWrapper>
            {showSkybetLink && (
                <Styled.SkyBetOddsWrapper href={skybetLinkHref}>
                    Check out your horse&apos;s latest odds on
                    <Styled.SkyBetLogo
                        src={`${PUBLIC_URL}/img/logos/skybet-secondary.png`}
                    />
                    <Styled.RightCaret
                        src={`${PUBLIC_URL}/img/right-caret.png`}
                    />
                </Styled.SkyBetOddsWrapper>
            )}
        </Styled.Wrapper>
    );
};

RunnerCard.defaultProps = {
    clothNumber: '',
    horseName: '-',
    jockeyName: '-',
    trainerName: '-',
    silk: `${PUBLIC_URL}/img/default-silk.png`,
    showSkybetLink: false,
    skybetLinkHref: 'https://skybet.com'
};

RunnerCard.propTypes = {
    clothNumber: PropTypes.string,
    horseName: PropTypes.string,
    jockeyName: PropTypes.string,
    trainerName: PropTypes.string,
    silk: PropTypes.string,
    showSkybetLink: PropTypes.bool,
    skybetLinkHref: PropTypes.string
};

export default RunnerCard;
